<template>
  <BaseTagInputSkill
    v-bind="$attrs"
    v-on="$listeners"
    v-model="tags"
    ref="input"
    :expandableFunction="expandableFunction"
    :tagsLengthMax="tagsLengthMax"
    :styleConfig="styleConfig"
    @enterdown="onEnterdown"
  >
    <template v-slot:input-left="props">
      <div :style="style.tagContainer">
        <TagPrimary
          v-for="(tag, index) in props.tags"
          :key="index"
          :enableClose="true"
          :style="style.tag"
          @close="() => removeTag(index)"
        >
          {{ tag }}
        </TagPrimary>
      </div>
    </template>
    <template v-slot:right="props">
      <div :style="style.right">
        <GoogleMaterialIconPrimary
          v-if="props.filled && !props.disabled"
          v-bind="attrs.closeIcon"
          content="close"
          @mousedown="clearAll"
          :style="style.closeIcon"
        />
        <GoogleMaterialIconPrimary
          v-bind="attrs.searchIcon"
          content="search"
          :disabled="props.disabled"
          @mousedown="searchBySkill"
          :style="style.searchIcon"
        />
      </div>
    </template>
    <template v-slot:dropdown-top="props">
      <div :style="style.dropdownTopPartition" />
      <div
        @click="addTag"
        :style="style.dropdownTop"
      >
        <div :style="style.optionLeft">
          <TextRegular>
            {{ props.input }}
          </TextRegular>
          <div :style="style.optionSubText">
            by skill
          </div>
        </div>
        <GoogleMaterialIconPrimary
          v-bind="attrs.addIcon"
          content="add"
          :style="style.addIconTop"
        />
      </div>
    </template>
    <template v-slot:option="props">
      <TagPrimary>
        {{ props.label }}
      </TagPrimary>
      <div :style="style.note">
        {{ getOptionNote(props.option) }}
      </div>
      <div :style="style.optionSubText">
        by skill
      </div>
    </template>
    <template v-slot:option-right>
      <GoogleMaterialIconPrimary
        v-bind="attrs.addIcon"
        content="add"
        :style="style.addIcon"
      />
    </template>
    <template v-slot:dropdown-bottom="props">
      <div
        @mousedown="searchByPerson(props.input)"
        :style="style.optionLeft"
      >
        <TextRegular>
          {{ props.input }}
        </TextRegular>
        <div :style="style.optionSubText">
          by person
        </div>
      </div>
      <GoogleMaterialIconPrimary
        v-bind="attrs.searchIcon"
        content="search"
        @mousedown="searchByPerson(props.input)"
        :style="style.searchIconBottom"
      />
    </template>
    <template v-slot:error="{ errorMessage }">
      {{ errorMessage }}
    </template>
  </BaseTagInputSkill>
</template>

<script>
  import BaseTagInputSkill from '@base/v2/base-tag-input-skill'
  import GoogleMaterialIconPrimary
    from '@modules/v2/icon/google-material-icon-primary'
  import TagPrimary from '@modules/v2/tag/tag-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { FontStyle, Layout } from '@js/styles'
  import { LENGTH_LIMITS } from '@js/constants'
  import { mapGetters } from 'vuex'

  const FORM_HEIGHT = '36px';

  export default {
    name: 'SearchExpertBoxPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change-tags',
    },
    components: {
      BaseTagInputSkill,
      GoogleMaterialIconPrimary,
      TagPrimary,
      TextRegular,
    },
    props: {
      vmodelValue: {
        type: Array,
        required: false,
        default: () => [],
      },
      tagsLengthMax: {
        type: Number,
        required: false,
        default: 5,
      },
    },
    data: function () {
      return {
        errorMessage: '',
        options: [],
        tags: [],
        attrs: {
          addIcon: {
            fontSize: '20px',
          },
          closeIcon: {
            fontSize: '20px',
          },
          searchIcon: {
            fontSize: '20px',
          },
        },
        style: {
          addIcon: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            margin: `0 ${Layout.space.md} 0 0`,
          },
          addIconTop: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
          },
          closeIcon: {
            alignItems: 'center',
            display: 'flex',
            height: '24px',
            padding: `0 ${Layout.space.sm} 0 0`,
          },
          dropdownTop: {
            alignItems: 'center',
            display: 'flex',
            height: '32px',
            width: '100%',
          },
          dropdownTopPartition: {
            height: '1px',
            width: '100%',
          },
          note: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.md,
            margin: `0 0 0 ${Layout.space.sm}`,
          },
          optionLeft: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
          },
          optionSubText: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontStyle: 'italic',
            fontWeight: FontStyle.weight.md,
            margin: `0 0 0 ${Layout.space.sm}`,
          },
          right: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end',
            margin: `0 ${Layout.space.md} 0 12px`,
          },
          searchIcon: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            padding: `0 0 0 ${Layout.space.sm}`,
          },
          searchIconBottom: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            margin: '0 12px 0 0',
          },
          tagContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            padding: '0 0 0 12px',
          },
          tag: {
            margin: `0 ${Layout.space.xs}`,
          },
        },
        styleConfig: {
          container: {
            borderRadius: Layout.space.sm,
            boxShadow: {
              '': '0 4px 16px rgba(0, 0, 0, 0.2)',
              disabled: 'none',
            },
            height: 'fit-content',
          },
          dropdown: {
            border: 'none',
            borderRadius: `0 0 ${Layout.space.sm} ${Layout.space.sm}`,
            borderWidth: 'none',
            padding: `0 0 ${Layout.space.sm} 0`,
            top: FORM_HEIGHT,
          },
          dropdownBottom: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            height: '32px',
            padding: `0 0 0 ${Layout.space.md}`,
            whiteSpace: 'nowrap',
            width: '100%',
          },
          dropdownCenter: {},
          dropdownLeft: {
            width: 0,
          },
          dropdownRight: {
            width: '48px',
          },
          dropdownTop: {
            display: 'flex',
            height: '40px',
            justifyContent: 'space-between',
            flexDirection: 'column',
            padding: `0 12px 0 ${Layout.space.md}`,
            whiteSpace: 'nowrap',
            width: '100%',
          },
          error: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.xs,
            fontWeight: FontStyle.weight.sm,
            padding: `6px 0 0 ${Layout.space.md}`,
            top: '32px',
          },
          form: {
            height: FORM_HEIGHT,
          },
          formPlaceholder: {
            height: FORM_HEIGHT,
          },
          input: {
            flex: 1,
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            height: FORM_HEIGHT,
            padding: `0 ${Layout.space.sm} 0 ${Layout.space.xs}`,
          },
          inputContainer: {
            height: 'fit-container',
            overflowX: 'auto',
            overflowY: 'hidden',
          },
          left: {},
          option: {
            alignItems: 'center',
            display: 'flex',
            width: '100%',
          },
          right: {
            height: '100%',
            justifyContent: 'flex-end',
          },
          row: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            height: '32px',
            padding: `0 ${Layout.space.md}`,
            width: '100%',
          },
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.closeIcon,
        {
          border: `solid ${this.color.dark5()}`,
          borderWidth: '0 1px 0 0',
        },
      );
      Object.assign(
        this.style.dropdownTopPartition,
        {
          backgroundColor: this.color.dark5(),
        },
      );

      Object.assign(
        this.styleConfig.dropdownBottom,
        {
          backgroundColor: {
            '': 'transparent',
            hover: this.color.dark6(),
            selected: this.color.dark6(),
          },
        },
      );
      Object.assign(
        this.styleConfig.dropdownTop,
        {
          backgroundColor: {
            '': 'transparent',
            hover: this.color.dark6(),
            selected: this.color.dark6(),
          },
        },
      );
      Object.assign(
        this.styleConfig.error,
        {
          color: this.color.warning1(),
        },
      );
      Object.assign(
        this.style.note,
        {
          color: this.color.dark3(),
        },
      );
      Object.assign(
        this.style.optionSubText,
        {
          color: this.color.dark3(),
        },
      );

      Object.assign(
        this.styleConfig.dropdown,
        {
          backgroundColor: this.color.light1(),
        },
      );
      Object.assign(
        this.styleConfig.input,
        {
          color: {
            '': this.color.dark2(),
            disabled: this.color.dark3(),
            placeholder: this.color.dark3(),
          },
        },
      );
      Object.assign(
        this.styleConfig.inputContainer,
        {
          backgroundColor: {
            '': this.color.light1(),
            disabled: this.color.shadow1(),
          },
          border: {
            '': 'none',
            disabled: `solid ${this.color.dark5()}`,
          },
          borderRadius: {
            '': `${Layout.space.sm} 0 0 ${Layout.space.sm}`,
            expandable: `${Layout.space.sm} 0 0 0`,
          },
          borderWidth: {
            '': 'none',
            disabled: '1px 0 1px 1px',
          },
        },
      );
      Object.assign(
        this.styleConfig.right,
        {
          backgroundColor: {
            '': this.color.light1(),
            disabled: this.color.shadow1(),
          },
          border: {
            '': 'none',
            disabled: `solid ${this.color.dark5()}`,
          },
          borderRadius: {
            '': `0 ${Layout.space.sm} ${Layout.space.sm} 0`,
            expandable: `0 ${Layout.space.sm} 0 0`,
          },
          borderWidth: {
            '': 'none',
            disabled: '1px 1px 1px 0',
          },
        },
      );
      Object.assign(
        this.styleConfig.row,
        {
          backgroundColor: {
            '': 'transparent',
            hover: this.color.dark6(),
            selected: this.color.dark6(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      addTag: function () {
        this.$refs.input.addTag();
      },
      clearAll: function () {
        this.$refs.input.clearAll();
      },
      expandableFunction: function (args) {
        return (
          args.errorMessage.length === 0 &&
          args.focus &&
          args.input.trim().length > 0
        );
      },
      getOptionNote: function (option) {
        return this.$refs.input.getOptionNote(option);
      },
      onEnterdown: function (input) {
        if (input.length > 0) {
          this.$refs.input.addTag(false);
        } else if (this.tags.length > 0) {
          this.$emit('search-by-skill-name', this.tags);
        }
      },
      removeTag: function (index) {
        this.$refs.input.removeTag(index);
      },
      searchByPerson: function (input) {
        this.$emit('search-by-person-name', input);
      },
      searchBySkill: function () {
        this.$refs.input.addTag(true);
        this.$emit('search-by-skill-name', this.tags);
      },
    },
    watch: {
      vmodelValue: {
        handler: function (newVal, oldVal) {
          this.tags = this.vmodelValue;
        },
        deep: true,
      },
    },
  };
</script>
